import { PartialFor } from "@omni/types/utils/partialFor";
import { Alert } from "@omni/ui/components/Alert/alert.component";
import { AlertProps } from "@omni/ui/components/Alert/alert.props";
import { useState } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const UncontrolledAlert = ({
    closeAriaLabel,
    ...props
}: PartialFor<AlertProps, "closeAriaLabel">) => {
    const { t } = useGranite();
    const [isOpen, setIsOpen] = useState(true);

    const toggle = () => setIsOpen(!isOpen);

    return (
        <Alert
            isOpen={isOpen}
            toggle={toggle}
            closeAriaLabel={closeAriaLabel || t("general.alert.close")}
            {...props}
        />
    );
};

export default UncontrolledAlert;
